import React from 'react';
import Header from '../components/landing/Header';
import Hero from '../components/landing/Hero';
import LoadboardMarquee from '../components/landing/LoadboardMarquee';
import Features from '../components/landing/Features';
import HowItWorks from '../components/landing/HowItWorks';
import DownloadSection from '../components/landing/DownloadSection';
import Testimonials from '../components/landing/Testimonials';
import FAQ from '../components/landing/FAQ';
import CTA from '../components/landing/CTA';
import Footer from '../components/landing/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-slate-950">
      <Header />
      <main>
        <Hero />
        <LoadboardMarquee />
        <Features />
        <HowItWorks />
        <DownloadSection />
        <Testimonials />
        <FAQ />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
